// Varsel når en ansatt logger inn (velger seg selv i menylinjen): åpne ordrer på den ansatte som er
// UBEHANDLET_FRA virkedager eller eldre. Vises hver gang, så lenge ordrene står åpne. NavBar
// monterer den med `key`, så den henter på nytt for hvert valg.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDialog } from './tilgjengelighet';
import Ikon from '../ny-kundesamhandling/Ikon';
import { knappPrimar, knappSekundar } from '../ny-kundesamhandling/Skjema';
import { hentMineOrdrer, erUbehandlet, UBEHANDLET_FRA, virkedagerTekst } from '../utils/mineOrdrer';

export default function UbehandledeOrdrer({ ansatt, onLukk }) {
  const [ordrer, setOrdrer] = useState([]);

  useEffect(() => {
    let aktiv = true;
    hentMineOrdrer(ansatt).then((liste) => {
      if (aktiv && liste) setOrdrer(liste.filter(erUbehandlet));
    });
    return () => { aktiv = false; };
  }, [ansatt]);

  const apen = ordrer.length > 0;
  const dialogRef = useDialog(apen, onLukk);
  if (!apen) return null;

  const butikkid = parseInt(Cookies.get('butikkid'), 10) || null;
  const fornavn = ansatt.split(' ')[0];

  return (
    <div className="no-print fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-black/40 p-3 sm:items-center">
      <div
        ref={dialogRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="uo-tittel"
        aria-describedby="uo-tekst"
        className="w-full max-w-lg space-y-3 rounded-2xl bg-white p-3 shadow-xl sm:p-5"
      >
        <div className="flex items-start gap-2">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-700 text-white">
            <Ikon navn="varsel" className="w-7 h-7" />
          </span>
          <div className="min-w-0">
            <h2 id="uo-tittel" className="text-lg font-bold text-slate-900 text-balance">
              {ordrer.length === 1 ? 'Du har en ubehandlet ordre' : `Du har ${ordrer.length} ubehandlede ordrer`}
            </h2>
            <p id="uo-tekst" className="mt-1 text-slate-700">
              Hei {fornavn}! {ordrer.length === 1 ? 'Denne ordren har stått åpen' : 'Disse ordrene har stått åpne'} i {UBEHANDLET_FRA}{' '}
              virkedager eller mer. Følg {ordrer.length === 1 ? 'den' : 'dem'} opp, eller avtal med en kollega som kan ta over. Er varen
              forsinket, kan du utsette varselet på ordren.
            </p>
          </div>
        </div>

        <ul className="max-h-[50vh] space-y-2 overflow-y-auto">
          {ordrer.map((o) => (
            <li key={o._id}>
              <Link
                to={`/order-details/${o._id}`}
                onClick={onLukk}
                className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl border-2 border-red-200 bg-red-50 px-3 py-1.5 hover:bg-red-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50"
              >
                <span className="font-mono text-sm font-semibold text-slate-700">Nr. {o.ordreid}</span>
                <span className="min-w-0 flex-1 font-semibold text-slate-900 [overflow-wrap:anywhere]">
                  {[o.Varemerke, o.Produkt].filter(Boolean).join(' ') || 'Uten navn'}
                </span>
                <span className="whitespace-nowrap text-sm font-semibold text-red-800">{virkedagerTekst(o.virkedager)}</span>
                {butikkid && o.butikkid !== butikkid && (
                  <span className="w-full text-sm text-slate-700">I den andre butikken</span>
                )}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap justify-end gap-2">
          <button type="button" onClick={onLukk} className={knappSekundar}>Lukk</button>
          <Link to="/ordre" onClick={onLukk} data-autofokus className={knappPrimar}>
            Se ordrene <Ikon navn="pil" className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
